module.exports = __webpack_public_path__ + "img/kp.569a247a.svg";